import http from '@/http'

const PATH = '/customers'

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listUserLogs ({customerId, params}) {
        try {
            const response = await http.get(`${PATH}/${customerId}/user-logs`, {
                params
            })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, logId: number}} data
     * @returns {Promise<void>}
     */
    async showUserLog ({customerId, logId}) {
        try {
            const response = await http.get(`${PATH}/${customerId}/user-logs/${logId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
